export default __webpack_public_path__ + "static/media/html5.8fe62fae.svg";